/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { CloseIcon, UserIcon } from 'assets/icons';
import { Input, Select, Textarea } from 'components';
import { Globals } from 'utils';
import { GeneralService, UsersService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface ModalEditCompanyProps {
  user?: any
  onClose: (reload?: boolean) => void
}

const ModalEditCompany = ({ user, onClose }: ModalEditCompanyProps) => {

  const [documentTypes, setDocumentTypes] = useState<any[]>([]);
  const [phoneCodes, setPhoneCodes] = useState<any[]>([]);
  const [form, setForm] = useState({
    user_id: '',
    photo: '',
    company_name: '',
    company_document_type_id: '',
    company_document: '',
    company_phonecode_id: '',
    company_phone: '',
    company_email: '',
    address: '',
    name: '',
    phonecode_id: '',
    phone: '',
    email: '',
    hasFile: false,
  });

  const onChange = (value: string | File, target: keyof typeof form) => {
    setForm({ ...form, [target]: value });
  }

  const getSelects = () => {
    Promise.all([
      GeneralService.getDocumentTypes(),
      GeneralService.getPhoneCodes(),
    ])
      .then((res: any[]) => {
        setDocumentTypes(res[0].map((x: any) => ({ value: String(x.id), label: x.name })) ?? []);
        setPhoneCodes(res[1].map((x: any) => ({ value: String(x.id), label: x.name })) ?? []);
      })
      .catch(console.log);
  }

  const validateForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.company_name)
      return Globals.showError('Debe ingresar el nombre de la empresa');

    if (!form.company_document_type_id)
      return Globals.showError('Debe ingresar el tipo de documento');

    if (!form.company_document)
      return Globals.showError('Debe ingresar el RIF');

    if (!form.company_phonecode_id)
      return Globals.showError('Debe ingresar el código de área de la empresa');

    if (!form.company_phone)
      return Globals.showError('Debe ingresar el teléfono de la empresa');

    if (!form.company_email)
      return Globals.showError('Debe ingresar el correo de la empresa');

    if (!form.address)
      return Globals.showError('Debe ingresar el nombre de la persona de contacto');

    if (!form.name)
      return Globals.showError('Debe ingresar el nombre de la persona de contacto');

    if (!form.phonecode_id)
      return Globals.showError('Debe ingresar el código de área de la persona de contacto');

    if (!form.phone)
      return Globals.showError('Debe ingresar el teléfono de la persona de contacto');

    if (!form.email)
      return Globals.showError('Debe ingresar el correo de la persona de contacto');

    onSubmit();
  }

  const onSubmit = async () => {
    try {
      await UsersService.updateCompany(form);
      Globals.showSuccess('Datos actualizados');
      onClose(true);

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  useEffect(() => {
    getSelects();
    setForm({
      user_id: user?.id,
      photo: user?.photo,
      company_name: user?.company_name,
      company_document_type_id: user?.company_document_type_id,
      company_document: user?.company_document,
      company_phonecode_id: user?.company_phonecode_id,
      company_phone: user?.company_phone,
      company_email: user?.company_email,
      address: user?.address,
      name: user?.name,
      phonecode_id: user?.phonecode_id,
      phone: user?.phone,
      email: user?.email,
      hasFile: false,
    });
  }, []);

  return (
    <form onSubmit={validateForm}>
      <header>
        <p className="title">Editar</p>
        <button type="button" className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <section className="head">
        <div className="user-photo">
          {form.photo ? (
            <img src={Globals.fromStorage(form.photo)} alt="Usuario" />
          ) : (
            <img className="user-icon" src={UserIcon} alt="Usuario" />
          )}
        </div>
      </section>

      <section className="body">
        <div className="col-x2">
          <Input
            label="Nombre"
            value={form.company_name}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'company_name')}
          />
        </div>
        <div className="document-group">
          <Select
            label="RIF"
            name="company_document_type_id"
            placeholder=" "
            value={form.company_document_type_id}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'company_document_type_id')}
            options={documentTypes}
          />
          <Input
            value={form.company_document}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'company_document')}
          />
        </div>
        <div className="phone-group">
          <Select
            label="Teléfono"
            name="company_phonecode_id"
            placeholder=" "
            value={form.company_phonecode_id}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'company_phonecode_id')}
            options={phoneCodes}
          />
          <Input
            value={form.company_phone}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'company_phone')}
          />
        </div>
        <div className="col-x2">
          <Input
            label="Correo"
            value={form.company_email}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'company_email')}
          />
        </div>
        <div className="col-x2">
          <Textarea
            rows={2}
            label="Dirección"
            value={form.address}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'address')}
          />
        </div>
      </section>

      <section className="body">
        <p className="section-title">Persona de Contacto</p>

        <div className="col-x2">
          <Input
            label="Nombre"
            value={form.name}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'name')}
          />
        </div>
        <div className="phone-group">
          <Select
            label="Teléfono"
            name="phonecode_id"
            placeholder=" "
            value={form.phonecode_id}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'phonecode_id')}
            options={phoneCodes}
          />
          <Input
            value={form.phone}
            onChange={(e: IonChangeEvent) => onChange(e.target.value, 'phone')}
          />
        </div>
        <Input
          label="Correo"
          value={form.email}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'email')}
        />
      </section>

      <div className="actions">
        <button>Guardar</button>
      </div>
    </form>
  );
}

export default ModalEditCompany;